import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output
} from "@angular/core";
import { PagingService } from "src/app/services/paging.service";
import { DealerResponse, SwaggerException } from "src/domain/client";
import { NgTemplateOutlet } from "@angular/common";
import { WorkshopInfoComponent } from "../workshop-info/workshop-info.component";
import { ButtonComponent } from "../../inputs/button/button.component";
import { TranslateModule } from "@ngx-translate/core";
import { AppError } from "src/app/state";

@Component({
  selector: "app-request-failed",
  templateUrl: "./request-failed.component.html",
  imports: [
    NgTemplateOutlet,
    WorkshopInfoComponent,
    ButtonComponent,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestFailedComponent implements OnInit {
  dealer = input<DealerResponse | undefined>();
  title = input<string>("request-fail.title");
  subtitle = input<string>("request-fail.subtitle");
  returnText = input<string>("request-fail.return");
  returnToPage = input<number>(1);
  returnButtonAbove = input<boolean>(false);
  message = input<SwaggerException | AppError | undefined>();

  returnClicked$ = output();
  constructor(public pagingService: PagingService) {}

  ngOnInit(): void {}

  returnClicked(_event: any) {
    this.returnClicked$.emit();
    this.pagingService.navigateToStep(this.returnToPage());
  }
}
